import { render } from "./NumericValue.vue?vue&type=template&id=ef5988e4"
import script from "./NumericValue.vue?vue&type=script&lang=js"
export * from "./NumericValue.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__